// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__caFZT","col":"styles_col__12TE_","fulfillmentStatus":"styles_fulfillmentStatus__1tfow","emailCol":"styles_emailCol__2-Ol1"};